import React, { Component } from 'react';
import { connect } from 'react-redux'
class DropDownSelect extends Component { // eslint-disable-line react/prefer-stateless-function
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {



        const { input, data,dis, meta: { touched, error } } = this.props;
        let values=Object.values(data)
        let keys=Object.keys(data)
        return (
            <div>
                <select {...input} className="form-control" disabled={dis}>
                    {keys.map((p,index) => {
                            return (
                                <option key={p} value={values[index]}>
                                    {p}
                                </option>
                            );
                    })}
                    
                </select>
                {touched && error && <span>{error}</span>}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {

    return {

    }
}
const mapDispatchToProps = (dispatch) => {
    return {

    };//setSearchCounterpartyParameter
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DropDownSelect);